import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Box, BoxProps, Flex, FlexProps, Link, Text } from 'rebass';

type StyledThirdPaneProps = BoxProps & {
  $thirdPaneVisible?: boolean;
};

// box-shadow: ${({ theme: any }) => theme.shadows.default};
const StyledThirdPane = styled(Box)<StyledThirdPaneProps>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  transform: translateX(100%);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0);
  z-index: 7;

  display: flex;
  flex-direction: column;

  ${(props) =>
    props.$thirdPaneVisible &&
    `
      transform: translateX(0%);
      box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.25);
    `}
`;

const ThirdPaneRelativeContainer = styled(Box)`
  position: relative;
`;

export interface ThirdPaneHook {
  visible: boolean;
  onToggle?: (visible: boolean) => void;
}

type ThirdPaneProps = ThirdPaneHook &
  BoxProps & {
    children?: React.ReactNode;
  };

const ThirdPane = (props: ThirdPaneProps): JSX.Element => {
  // build toggle in and out
  return (
    <StyledThirdPane
      {...(props as any)}
      className="third-pane"
      $thirdPaneVisible={props.visible}
      bg="paneBg"
      maxWidth={[
        'calc(100vw - 56px)',
        'calc(100vw - 56px)',
        'calc(100vw - 270px)',
      ]}
    >
      {props.children}
    </StyledThirdPane>
  );
};

export default ThirdPane;

/************************************
 *
 * New
 *
 ************************************/

type ThirdPaneColumnHeaderProps = FlexProps & {
  title: string;
  children?: React.ReactNode;
  actions?: React.ReactNode;
};

export const ThirdPaneColumnHeader = ({
  title,
  children,
  ...props
}: ThirdPaneColumnHeaderProps) => {
  return (
    <Flex
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      px={5}
      pt={5}
      pb={3}
      {...(props as any)}
    >
      <Text>{title}</Text>

      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ gap: '12px' }}
      >
        {/* Put your icon buttons here */}
        {children}
      </Flex>
    </Flex>
  );
};

type FilterLinkProps = {
  active?: boolean;
  disabled?: boolean;
  children?: string;
  onClick?: any;
};

export const FilterLink = ({
  disabled,
  active = false,
  children,
  onClick,
}: FilterLinkProps) => {
  //
  return (
    <Link
      pl={1}
      pr={3}
      py="2px"
      href="#"
      color={active ? 'black' : 'base.gray.500'}
      sx={{
        textDecoration: active ? 'underline' : 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
        '&[disabled]': {
          // cursor: 'not-allowed',
          // color: 'base.gray.400',
          pointerEvents: 'none',
        },
      }}
      onClick={onClick}
      disabled={disabled}
    >
      <Text
        fontSize="14px"
        lineHeight="16px"
        fontWeight="regular"
        color="inherit"
      >
        {children}
      </Text>
    </Link>
  );
};

export const mockFilterLinks = ['All', 'Tests', 'Status', 'Comments'];

type FilterLinkRowProps = any;

export const FilterLinkRow = (props: FilterLinkRowProps) => {
  const [activeFilter, setActiveFilter] = useState<number>(0);
  //
  return (
    <Flex>
      {mockFilterLinks.map((item, i) => (
        <FilterLink
          key={i}
          active={i === activeFilter}
          onClick={() => setActiveFilter(i)}
        >
          {item}
        </FilterLink>
      ))}
    </Flex>
  );
};

// export const TimelineItem = () => {
//   return (
//     <Flex bg="red" alignItems="flex-start">
//       <Text
//         fontFamily="root"
//         fontSize="12px"
//         fontStyle="italic"
//         lineHeight="16px"
//       >
//         {/* {suffix} */}
//         UPDATE THIS
//       </Text>
//     </Flex>
//   )
// }
